import { useState, type JSX } from 'react'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { useToast } from '../../system/ToastProvider.js'

export interface TwilioWebhookUrlPanelProps {
  url: string
}

export default function TwilioWebhookUrlPanel(props: TwilioWebhookUrlPanelProps): JSX.Element {
  const toast = useToast()
  const [copied, setCopied] = useState(false)

  async function handleCopy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(props.url)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (e) {
      // Clipboard write failed (e.g. permission denied or insecure context).
      // Do not flip to "Copied!" state; surface the failure via toast instead
      // of silently no-oping.
      toast.error('Failed to copy', e instanceof Error ? e.message : 'Failed to copy webhook URL to clipboard.')
    }
  }

  return (
    <div className="rounded border border-gray-200 bg-gray-50 p-3">
      <div className="mb-1 text-xs font-medium text-gray-600">
        Webhook URL (paste into Twilio Console)
      </div>
      <div className="flex items-center gap-2">
        <InputText
          value={props.url}
          readOnly
          aria-label="Twilio webhook URL"
          className="flex-1 text-xs"
        />
        <Button
          icon="pi pi-copy"
          label={copied ? 'Copied!' : 'Copy'}
          onClick={() => void handleCopy()}
          aria-label="Copy webhook URL"
          size="small"
          severity={copied ? 'success' : undefined}
        />
      </div>
    </div>
  )
}
